import { getAffiliateLink } from '../config/site'
import './ReviewCard.css'

const ReviewCard = ({ review }) => {
  if (!review || typeof review !== 'object') return null

  const affiliateLink = review.signup_link || getAffiliateLink()
  const rating = review.rating || 0
  const stars = '⭐'.repeat(Math.floor(rating))

  return (
    <div className="review-card">
      <div className="review-header">
        <h3 className="review-name">{review.name}</h3>
        <div className="review-rating">
          {stars} {rating}/5
        </div>
      </div>
      
      <p className="review-description">{review.description}</p>
      
      <div className="review-pros-cons">
        {review.pros && review.pros.length > 0 && (
          <div className="review-pros">
            <h4>Vorteile:</h4>
            <ul>
              {review.pros.map((pro, i) => (
                <li key={i}>{pro}</li>
              ))}
            </ul>
          </div>
        )}
        
        {review.cons && review.cons.length > 0 && (
          <div className="review-cons">
            <h4>Nachteile:</h4>
            <ul>
              {review.cons.map((con, i) => (
                <li key={i}>{con}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
      
      {review.signup_link && (
        <a 
          href={affiliateLink} 
          target="_blank" 
          rel="noopener noreferrer"
          className="review-cta"
        >
          {review.cta || 'Jetzt anmelden'} →
        </a>
      )}
    </div>
  )
}

export default ReviewCard

